import { ProjectIssueType } from "@/libraries/bxp-web-stargate-client/src";

import {
    USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
    USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
    USER_SEGMENTATION_TEAM_TYPE_DESIGN,
    USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
    USER_SEGMENTATION_TEAM_TYPE_SOFTWARE
} from "../../../models/user-segmentation";
import commonMessages from "../common/messages";
import { IssueTypeIconName } from "../wizard/assets/issue-type-svgs";

import messages from "./messages";

import type { MessageDescriptor } from "react-intl";

export const USER_SEGMENTATION_TEAM_TYPE_UNKNOWN = "unknown";

export interface IssueType {
    name: MessageDescriptor;
    description: MessageDescriptor;
    icon: IssueTypeIconName;
    avatarId: number;
    id: string;
}
export interface IssueTypeWizardUI extends IssueType {
    isPreSelected: boolean;
}
export interface Configuration {
    issueTypes: IssueTypeWizardUI[];
    columns: MessageDescriptor[];
}

export type ProjectConfig = {
    issueTypes: ProjectIssueType[];
    columns: string[];
    projectName: string;
};

const featureIssueType: IssueType = {
    name: messages.featureIssueTypeName,
    description: messages.featureIssueTypeDescription,
    icon: "Feature",
    avatarId: 10314,
    id: "1"
};
const taskIssueType: IssueType = {
    name: messages.taskIssueTypeName,
    description: messages.taskIssueTypeDescription,
    icon: "Task",
    avatarId: 10318,
    id: "14"
};
const storyIssueType: IssueType = {
    name: messages.storyIssueTypeName,
    description: messages.storyIssueTypeDescription,
    icon: "Story",
    avatarId: 10315,
    id: "3"
};
const bugIssueType: IssueType = {
    name: messages.bugIssueTypeName,
    description: messages.bugIssueTypeDescription,
    icon: "Bug",
    avatarId: 10303,
    id: "4"
};
const assetIssueType: IssueType = {
    name: messages.assetIssueTypeName,
    description: messages.assetIssueTypeDescription,
    icon: "Asset",
    avatarId: 10309,
    id: "5"
};
const contactIssueType: IssueType = {
    name: messages.contactIssueTypeName,
    description: messages.contactIssueTypeDescription,
    icon: "Contact",
    avatarId: 10322,
    id: "6"
};
const requestIssueType: IssueType = {
    name: messages.requestIssueTypeName,
    description: messages.requestIssueTypeDescription,
    icon: "Request",
    avatarId: 10311,
    id: "7"
};
const researchItemIssueType: IssueType = {
    name: messages.researchItemIssueTypeName,
    description: messages.researchItemIssueTypeDescription,
    icon: "ResearchItem",
    avatarId: 10320,
    id: "8"
};
const incidentIssueType: IssueType = {
    name: messages.incidentIssueTypeName,
    description: messages.incidentIssueTypeDescription,
    icon: "Incident",
    avatarId: 10304,
    id: "9"
};
const serviceRequestIssueType: IssueType = {
    name: messages.serviceRequestIssueTypeName,
    description: messages.serviceRequestIssueTypeDescription,
    icon: "ServiceRequest",
    avatarId: 10308,
    id: "10"
};
const supportIssueType: IssueType = {
    name: messages.supportIssueTypeName,
    description: messages.supportIssueTypeDescription,
    icon: "Support",
    avatarId: 10306,
    id: "11"
};
const campaignIssueType: IssueType = {
    name: messages.campaignIssueTypeName,
    description: messages.campaignIssueTypeDescription,
    icon: "Campaign",
    avatarId: 10313,
    id: "12"
};
const candidateIssueType: IssueType = {
    name: messages.candidateIssueTypeName,
    description: messages.candidateIssueTypeDescription,
    icon: "Candidate",
    avatarId: 10322,
    id: "13"
};
const projectManagementWizardConfiguration: Configuration = {
    issueTypes: [
        { ...featureIssueType, isPreSelected: true },
        { ...taskIssueType, isPreSelected: true },
        { ...storyIssueType, isPreSelected: false },
        { ...bugIssueType, isPreSelected: false },
        { ...assetIssueType, isPreSelected: false }
    ],
    columns: [
        messages.ideaColumnName,
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.inReviewColumnName,
        messages.doneColumnName
    ]
};
const productManagementWizardConfiguration: Configuration = {
    issueTypes: [
        { ...featureIssueType, isPreSelected: true },
        { ...taskIssueType, isPreSelected: true },
        { ...storyIssueType, isPreSelected: false },
        { ...bugIssueType, isPreSelected: false }
    ],
    columns: [
        messages.ideaColumnName,
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.testingColumnName,
        messages.doneColumnName
    ]
};
const otherPersonalWizardConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType, isPreSelected: true },
        { ...assetIssueType, isPreSelected: false },
        { ...contactIssueType, isPreSelected: false },
        { ...requestIssueType, isPreSelected: false }
    ],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.doneColumnName
    ]
};
const designWizardConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType, isPreSelected: true },
        { ...assetIssueType, isPreSelected: true },
        { ...requestIssueType, isPreSelected: false },
        { ...researchItemIssueType, isPreSelected: false }
    ],
    columns: [
        messages.todoColumnName,
        messages.inDesignColumnName,
        messages.userTestingColumnName,
        messages.approvedColumnName,
        messages.liveColumnName
    ]
};
const itSupportWizardConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType, isPreSelected: true },
        { ...incidentIssueType, isPreSelected: true },
        { ...serviceRequestIssueType, isPreSelected: true },
        { ...supportIssueType, isPreSelected: false }
    ],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.waitingForCustomerColumnName,
        messages.resolvedColumnName
    ]
};

const softwareDevelopmentWizardConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType, isPreSelected: true },
        { ...storyIssueType, isPreSelected: true },
        { ...featureIssueType, isPreSelected: false },
        { ...requestIssueType, isPreSelected: false },
        { ...bugIssueType, isPreSelected: false }
    ],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.inReviewColumnName,
        messages.doneColumnName
    ]
};

export const noTeamTypeWizardConfiguration: Configuration = {
    issueTypes: [
        { ...featureIssueType, isPreSelected: true },
        { ...taskIssueType, isPreSelected: true },
        { ...storyIssueType, isPreSelected: false },
        { ...bugIssueType, isPreSelected: false },
        { ...requestIssueType, isPreSelected: false }
    ],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.inReviewColumnName,
        messages.doneColumnName
    ]
};

export const wizardConfigurations: { [teamType: string]: Configuration } = {
    [USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT]:
        projectManagementWizardConfiguration,
    "Project Management": projectManagementWizardConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT]:
        productManagementWizardConfiguration,
    "Product Management": productManagementWizardConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL]:
        otherPersonalWizardConfiguration,
    "Other or Personal": otherPersonalWizardConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_DESIGN]: designWizardConfiguration,
    "Design": designWizardConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT]: itSupportWizardConfiguration,
    "IT Support": itSupportWizardConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_UNKNOWN]: noTeamTypeWizardConfiguration,
    "Software Development": softwareDevelopmentWizardConfiguration,
    [USER_SEGMENTATION_TEAM_TYPE_SOFTWARE]:
        softwareDevelopmentWizardConfiguration,
    "": noTeamTypeWizardConfiguration
};

export const defaultWizardConfiguration: Configuration = {
    issueTypes: [
        { ...taskIssueType, isPreSelected: true },
        { ...requestIssueType, isPreSelected: false },
        { ...campaignIssueType, isPreSelected: false },
        { ...candidateIssueType, isPreSelected: false },
        { ...assetIssueType, isPreSelected: false }
    ],
    columns: [
        messages.todoColumnName,
        messages.inProgressColumnName,
        messages.doneColumnName
    ]
};

export interface ProjectDetails {
    projectKey: string;
    template: string;
    defaultProjectName: {
        id: string;
        defaultMessage: string;
        description: string;
    };
}

export const KANBAN_PROJECT_DEFAULTS = {
    projectKey: "KAN",
    template: "KANBAN",
    defaultProjectName: commonMessages.defaultProjectName
};

export const SCRUM_PROJECT_DEFAULTS = {
    projectKey: "SCRUM",
    template: "SCRUM",
    defaultProjectName: commonMessages.defaultScrumProjectName
};

export const JSM_PROJECT_DEFAULTS: ProjectDetails = {
    projectKey: "JSM",
    template: "JSM",
    defaultProjectName: commonMessages.defaultJsmProjectName
};

export const JPD_PROJECT_DEFAULTS: ProjectDetails = {
    projectKey: "JPD",
    template: "JPD",
    defaultProjectName: commonMessages.defaultJpdProjectName
};

export const CSM_PROJECT_DEFAULTS: ProjectDetails = {
    projectKey: "CSM",
    template: "CSM",
    defaultProjectName: commonMessages.defaultCsmProjectName
};
